export default "__VITE_ASSET__CiSwoPT8__"